import {
    useMemo,
} from 'react'
import {
    createRoutesConfig,
    SkyNetRoutesConfig,
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useCreateSkyNetDomainRoutes from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    App,
    ContainerManagementDomains,
    ContainersTabs,
    ServiceCenterTabs,
} from 'app/enums/domain.enums'

export default function useContainerManagementRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const SkyNetDomainRoutes = useCreateSkyNetDomainRoutes()()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [App.Containers],
            Containers: {
                route: ContainerManagementDomains.Containers,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeStatus: {
                    route: ContainersTabs.ChangeStatus,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Loggers: {
                    route: ContainersTabs.Loggers,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                SensorData: {
                    route: ContainersTabs.SensorData,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                AutomatedSensorChecks: {
                    route: ContainersTabs.AutomatedSensorChecks,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Damages: {
                    route: ContainersTabs.Damages,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Geolocation: {
                    route: ContainersTabs.GeoLocation,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: ContainersTabs.GeoLocation,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            ContainerDashboard: {
                route: ContainerManagementDomains.ContainerDashboard,
            },
            ContainerTypes: {
                route: ContainerManagementDomains.ContainerTypes,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            ServiceCenters: {
                route: ContainerManagementDomains.ServiceCenters,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                PoolingDataUpdate: {
                    route: ServiceCenterTabs.PoolingDataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                DailyOpsDataUpdate: {
                    route: ServiceCenterTabs.DailyOpsDataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Monitoring: {
                    route: ServiceCenterTabs.Monitoring,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ScenarioEditor: {
                    route: ServiceCenterTabs.ScenarioEditor,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                WorkSchedule: {
                    route: ServiceCenterTabs.WorkSchedule,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                RelatedOrders: {
                    route: ServiceCenterTabs.RelatedOrders,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        SkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
